import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect, useDispatch } from "react-redux";
import { css } from "styled-components";
import getQuoteHistoryExportHandler from "@NA/Handlers/ADIQuoteHistoryExportHandler";
import Button from "@insite/mobius/Button";
import ExportIcon from "@NA/Icons/ExportIcon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Icon from "@insite/mobius/Icon";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import Select from "@insite/mobius/Select";
import Hidden from "@insite/mobius/Hidden";
import FilterIcon from "@NA/Icons/FilterIcon";
import ordersListParameter from "@NA/Handlers/ADIOrdersListParameterHandler";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { getDisplayRange, getPaginationMessage } from "@NA/Utils/Utility";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
const mapStateToProps = (state: CustomApplicationState) => ({
    session: state.context.session,
    ordersDataView: state.ADIGlobalData.ordersListStore.ordersList,
    isLoading: state.ADIGlobalData.ordersListStore.isLoading,
    getOrdersParameter: state.ADIGlobalData.ordersListStore.parameter,
});

const mapDispatchToProps = {
    getQuoteHistoryExportHandler,
    ordersListParameter,
};

export interface BranchLinkStyles {
    exportButton?: InjectableCss;
    Icons?: InjectableCss;
    searchResult?: InjectableCss;
    pageresults?: InjectableCss;
    pageSizeSelect?: InjectableCss;
    quoteHeaderPagWrap?: InjectableCss;
    quoteHeaderSearchResult?: InjectableCss;
    quoteHeaderPageSize?: InjectableCss;

    mobSearchResult?: InjectableCss;
    mobPageSizeSelect?: InjectableCss;
    mobSearchResultWrap?: InjectableCss;
    mobPageresults?: InjectableCss;
}

export const branchLinkStyles: BranchLinkStyles = {
    exportButton: {
        css: css`
            background: transparent;
            color: ${getColor("primary")};
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            line-height: normal;
            outline: none;
            border: none;
            display: flex;
            align-items: center;
            padding: 9px 10px;
            margin-left: 4px;
            &:hover {
                text-decoration: underline;
                background: transparent;
            }
            &:focus {
                outline: none;
            }
        `,
    },
    Icons: {
        css: css`
            height: 17px;
            width: 17px;
            margin: 1px 6px 1px 0;
            > svg {
                width: 17px;
                height: 17px;
            }
        `,
    },
    quoteHeaderPagWrap: {
        css: css`
            margin-top: 21px;
            padding: 0px 20px;
            margin-bottom: 13px;
            border-top: 0px solid #bbb;
            width: 100%;
            height: 59px;
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        height: 51px;
                        align-items: flex-end;
                        background-color: #f7f7f7;
                        border-top: 1px solid #bbb;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    quoteHeaderSearchResult: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
        `,
    },
    searchResult: {
        css: css`
            font-size: 20px;
            font-weight: 800;
            line-height: 1.25;
            color: ${ADIColors.darkBlue1};
            margin: 0 12px 0 0;
            flex-basis: 100%;
            max-width: 100%;
            span {
                white-space: nowrap;
            }
        `,
    },
    pageresults: {
        css: css`
            font-size: 14px;
            margin-top: 4px;
            border-right: 1px solid ${ADIColors.gray3};
            padding-right: 8px;
            flex-basis: 100%;
            max-width: 100%;
            span {
                white-space: nowrap;
            }
        `,
    },
    quoteHeaderPageSize: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px !important;
            label {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                width: auto;
                                padding: 0px 8px 0 0;
                                margin: auto 0;
                                font-weight: 800;
                            `,
                    ],
                    "max",
                );
            }}
            }
            div {
                width: auto !important;
                margin-top: 0px !important;
            }
            select {
                height: 38px !important;
                border: solid 1px #bbb !important;
                font-size: 14px !important;
                &:focus {
                    outline-width: unset !important;
                    box-shadow: none !important;
                    border: solid 1px #bbb !important;
                    padding: 9px 32px 9px 15px !important;
                    outline-color: transparent !important;
                }
            }
        `,
    },
    pageSizeSelect: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobSearchResult: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
        `,
    },
    mobPageSizeSelect: {
        css: css`
            display: flex;
            align-items: center;
            margin-top: 5px !important;
            select {
                height: 38px;
                max-width: 83px;
                padding: 9px 7px 8px 16px;
                line-height: 16px;
                padding-right: 25px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                border: solid 1px #bbb !important;
                font-size: 14px !important;
                &:focus {
                    outline-width: unset !important;
                    box-shadow: none !important;
                    border: solid 1px #bbb !important;
                    padding: 9px 15px !important;
                    outline-color: transparent !important;
                }
            }
            label {
                width: unset !important;
                padding-top: 0;
                display: flex;
                align-items: center;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                padding: 0px 8px 0 0;
                                font-weight: 800;
                                text-transform: initial;
                            `,
                    ],
                    "max",
                );
            }}
            }
            div {
                width: auto !important;
                margin-top: 0px !important;
            }
            button {
                width: 41px;
                height: 38px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                margin-left: 12px;
                min-height: 38px;
                padding: 8px 12px 10px 12px;
                border-radius: 6px;
                border: solid 1px #bbb;
                background-color: #fff;
                color: #006ae3;
                &:active {
                    background-color: #006ae3;
                    border: 1px solid #006ae3;
                }
            }
        `,
    },
    mobSearchResultWrap: {
        css: css`
            margin-bottom: 0 !important;
            border-top: 1px solid ${ADIColors.gray3};
            float: left;
            width: 100%;
            margin-top: 24px;
            padding-top: 16px;
        `,
    },
    mobPageresults: {
        css: css`
            font-size: 14px;
            margin-top: 4px;
            padding-right: 8px;
            flex-basis: 100%;
            max-width: 100%;
            margin-top: 5px;
            margin-bottom: 5px;
            span {
                white-space: nowrap;
            }
        `,
    },
};

interface OwnProps extends WidgetProps { }

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const styles = branchLinkStyles;
const ADIOrderHeaderPagination = ({
    getQuoteHistoryExportHandler,
    ordersDataView,
    ordersListParameter,
    getOrdersParameter,
    isLoading,
}: Props) => {
    const [sortOrder, setSortOrder] = useState("CreationDate");
    const dispatch = useDispatch();
    const [selectedFromDropdown, setSelectedFromDropdown] = useState(false);
    const [range, setRange] = useState({ start: 0, end: 0 });
    const handleQuoteHistoryExport = () => {
        getQuoteHistoryExportHandler({
            ...getOrdersParameter,
        });
    };

    useEffect(() => {
        if (!getOrdersParameter.isSearchActive) {
            dispatch({
                type: "Custom/DispatchUpdateResetPagination",
            });
        }
    }, []);

    useEffect(() => {
        if (ordersDataView && getOrdersParameter && ordersDataView.pagination) {
            const { start, end } = getDisplayRange(ordersDataView.pagination, getOrdersParameter);
            setRange({ start, end });
        }
    }, [ordersDataView, getOrdersParameter])

    const changeResultsPerPage = (event: React.FormEvent<HTMLSelectElement>) => {
        setSelectedFromDropdown(true);

        ordersListParameter({
            ...getOrdersParameter,
            pageSize: event.currentTarget.value,
            page: 1,
        });
    };

    const changeResultsSortBy = (event: React.FormEvent<HTMLSelectElement>) => {
        handleSortOrder(event.currentTarget.value);
        setSortOrder(event.currentTarget.value);
    };

    const handleButtonSortOrder = (sortData: string) => {
        handleSortOrder(sortData);
    };

    const handleSortOrder = (sort: string) => {
        let sortData = sort;
        getOrdersParameter?.sort === sortData ? (sortData = `${sortData} DESC`) : (sortData = sort);
        ordersListParameter({
            ...getOrdersParameter,
            sort: sortData,
        });
    };

    return (
        <>
            {ordersDataView?.pagination?.totalItemCount !== 0 && !isLoading && (
                <StyledWrapper>
                    <Hidden below="md">
                        <StyledWrapper {...styles.quoteHeaderPagWrap}>
                            <StyledWrapper {...styles.quoteHeaderSearchResult}>
                                <StyledWrapper {...styles.searchResult}>
                                    {!getOrdersParameter.isSearchActive ? (
                                        <Typography>{translate(`Recent Orders`)}</Typography>
                                    ) : (
                                        <Typography>{translate(`Search Results`)}</Typography>
                                    )}
                                </StyledWrapper>
                                <StyledWrapper {...styles.pageresults}>
                                    {ordersDataView?.pagination && (
                                        <Typography>
                                            {translate(
                                                `Showing ${getPaginationMessage(
                                                    ordersDataView?.pagination?.page,
                                                    ordersDataView?.pagination?.pageSize,
                                                    ordersDataView?.pagination?.totalItemCount,
                                                )} `,
                                            )}
                                        </Typography>
                                    )}
                                </StyledWrapper>
                                <Button shape="rounded" {...styles.exportButton} onClick={handleQuoteHistoryExport}>
                                    <Icon src={ExportIcon} color="primary" {...styles.Icons} />
                                    {translate("Export")}
                                </Button>
                            </StyledWrapper>
                            <StyledWrapper {...styles.quoteHeaderPageSize}>
                                <Select
                                    className="pageSize"
                                    {...styles.pageSizeSelect}
                                    label={translate("Per Page")}
                                    value={ordersDataView?.pagination?.pageSize}
                                    labelPosition="left"
                                    onChange={changeResultsPerPage}
                                    data-test-selector="productListSortSelect"
                                >
                                    {ordersDataView?.pagination?.pageSizeOptions
                                        .filter(option => option <= 36)
                                        .map(options => (
                                            <option key={options} value={options}>
                                                {options}
                                            </option>
                                        ))}
                                </Select>
                            </StyledWrapper>
                        </StyledWrapper>
                    </Hidden>

                    <Hidden above="sm">
                        <StyledWrapper {...styles.mobSearchResultWrap}>
                            <StyledWrapper {...styles.mobSearchResult}>
                                <StyledWrapper {...styles.searchResult}>
                                    {!getOrdersParameter.isSearchActive ? (
                                        <Typography>{translate(`Recent Orders`)}</Typography>
                                    ) : (
                                        <Typography>{translate(`Search Results`)}</Typography>
                                    )}
                                </StyledWrapper>
                                <Button shape="rounded" {...styles.exportButton} onClick={handleQuoteHistoryExport}>
                                    <Icon src={ExportIcon} color="primary" {...styles.Icons} />
                                    {translate("Export")}
                                </Button>
                            </StyledWrapper>
                            <StyledWrapper {...styles.mobPageresults}>

                                {ordersDataView?.pagination && (
                                    <Typography>
                                        {translate(
                                            `Showing ${getPaginationMessage(
                                                ordersDataView?.pagination?.page,
                                                ordersDataView?.pagination?.pageSize,
                                                ordersDataView?.pagination?.totalItemCount,
                                            )} `,
                                        )}
                                    </Typography>

                                )}

                            </StyledWrapper>
                            <StyledWrapper {...styles.mobSearchResult}>
                                <StyledWrapper {...styles.mobPageSizeSelect}>
                                    <Select
                                        className="pageSize"
                                        {...styles.pageSizeSelect}
                                        label={translate("Sort by")}
                                        value={sortOrder}
                                        labelPosition="left"
                                        onChange={changeResultsSortBy}
                                        data-test-selector="productListSortSelect"
                                    >
                                        <option key="CreationDate" value="CreationDate">
                                            {translate("Date")}
                                        </option>
                                        <option key="Order Number" value="Order Number">
                                            {translate("Order #")}
                                        </option>
                                        <option key="customerPO" value="customerPO">
                                            {translate("PO #")}
                                        </option>
                                        <option key="ErpOrderNumber" value="ErpOrderNumber">
                                            {translate("Reference #")}
                                        </option>
                                        <option key="orderDate" value="orderDate">
                                            {translate("Exp. Date")}
                                        </option>
                                        <option key="OrderTotal" value="OrderTotal">
                                            {translate("Total")}
                                        </option>
                                    </Select>
                                    <Button variant="secondary" onClick={() => handleButtonSortOrder(sortOrder)}>
                                        <Icon src={FilterIcon} />
                                    </Button>
                                </StyledWrapper>
                                <StyledWrapper {...styles.quoteHeaderPageSize}>
                                    <Select
                                        className="pageSize"
                                        {...styles.pageSizeSelect}
                                        label={translate("Per Page")}
                                        value={ordersDataView?.pagination?.pageSize}
                                        labelPosition="left"
                                        onChange={changeResultsPerPage}
                                        data-test-selector="productListSortSelect"
                                    >
                                        {ordersDataView?.pagination?.pageSizeOptions
                                            .filter(option => option <= 36)
                                            .map(options => (
                                                <option key={options} value={options}>
                                                    {options}
                                                </option>
                                            ))}
                                    </Select>
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </Hidden>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIOrderHeaderPagination),
    definition: {
        displayName: "ADI Order Header Pagination",
        icon: "branch",
        fieldDefinitions: [],
        group: "Common",
    },
};

export default widgetModule;
